<script setup lang="ts">
import { useAttrs } from 'vue'
import { Primitive } from 'reka-ui'
import { buttonVariants } from '.'
import { cn } from '@/lib/utils'

defineOptions({
  inheritAttrs: false
})

interface ButtonProps {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link'
  size?: 'default' | 'sm' | 'lg' | 'icon'
  as?: string
  asChild?: boolean
}

const props = withDefaults(defineProps<ButtonProps>(), {
  variant: 'default',
  as: 'button'
})
const attrs = useAttrs()
</script>

<template>
  <Primitive
    v-bind="attrs"
    :as="props.as"
    :as-child="props.asChild"
    :class="cn(buttonVariants({ variant: props.variant, size: props.size }), attrs.class ?? '')"
    class="tracking-wide"
  >
    <slot />
  </Primitive>
</template>
